import React, { Component } from 'react'

import Modal from './Modal'
import IconNew from '../icons/toolbar/menu/filter/category/New'

import Backend from '../../../utils/Backend'

export default class CategoryMenuModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
      filter: props.filter,
      categories: [],
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  componentDidMount(){
    this._loadCategories()
  }

  _loadCategories(){
    Backend.getCategories()
    .then(categories => {
      this.setState({ categories })
    })
  }

  _addToCategory(category){
    let { filter } = this.state

    let data = {
      name: filter.name,
      key: filter.key,
      type: "in_category",
      data: filter.data,
      category: category.id
    }

    this.setState({ loading: true })
    Backend.addFilterToCategory(data)
    .then(() => {
      this.setState({ loading: false })
      this.props.onAdded(filter)
    })
    .catch(error => {
      alert(error.message)
      this.setState({ loading: false })
    })
  }

  render() {
    let { loading, categories } = this.state
    return (
      <Modal
        className="p-category"
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <div>
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => this.props.onNewCategoryClick()}
          >
            New Category
            <IconNew />
          </button>
          <ul>
            { categories.map(category => {
                return (
                  <li key={category.id}>
                    <a disabled={loading} onClick={() => this._addToCategory(category)}>
                      {category.name}
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </Modal>
    )
  }
}
